import { KalSelectionModel } from '@kalidea/kaligraphi';
import { arrayEmpty } from 'src/app/utils/array.utils';

export function normalizeList<T>(list: T[], propertyId: keyof T): T[] {
    list.forEach((e: T & { id: string }) => {
        e.id = '' + e[propertyId];
    });
    return list;
}

export function denormalizeList<T>(list: T[], propertyId: keyof T): T[] {
    list.forEach((e: T & { id: string }) => {
        delete e.id;
    });
    return list;
}

export function filterListFromSelection<T>(list: T[], selection: KalSelectionModel<T>, property: keyof T): T[] {
    if (!selection) {
        return list;
    }

    return selection.all ? list.filter(e => !selection.removed.some(item => ('' + item[property]) === ('' + e[property]))) : selection.added;
}

/**
 * Permet un tri customisable pour plusieurs valeurs d'une propriété
 * @param data tableau d'éléments à trier
 * @param valuesOrder tableau indiquant l'ordre des valeurs dans lequel les éléments doivent être triés
 * @param sortProperty propriété à utiliser pour effectuer le tri
 * @example
 * list: BenefODADModel[] = [
 *  {..., CodeTypeAD: 'EXT', ...},
 *  {..., CodeTypeAD: 'CON', ...},
 *  {..., CodeTypeAD: 'ENF', ...}
 * ];
 * result = customSort(list, 'CodeTypeAD', ['CON', 'ENF', 'EXT']);
 * // result = [
 * //   {..., CodeTypeAD: 'CON', ...},
 * //   {..., CodeTypeAD: 'ENF', ...},
 * //   {..., CodeTypeAD: 'EXT', ...}
 * // ]
 */
export function customSort<T>(data: T[], sortProperty: keyof T, valuesOrder: string[]) {
    if (arrayEmpty(data)) {
        return [];
    }

    const sortByObject = valuesOrder.reduce((obj: T, item: string, index: any) => {
        return {
            ...obj,
            [item]: index
        };
    }, {});

    return data.sort((a, b) => sortByObject[a[sortProperty as string]] - sortByObject[b[sortProperty as string]]);
}
